import axios from 'axios'

export const TAGS_URL = process.env.REACT_APP_API_ENDPOINT + '/api/tags'

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findTags() {
	return axios.post(TAGS_URL)
}
